// inv/src/components/LanguageSwitcher.jsx
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChevronDown, ChevronUp } from "lucide-react";
import languageIcon from "../icons/language.svg";
import { languagePrefixes } from "../i18n";
import { cn } from "../lib/utils";

const LanguageSwitcher = ({ currentLanguage, changeLanguage, onClick, triggerClassName }) => {
  const [open, setOpen] = React.useState(false);
  const close = () => setOpen(false);

  const languages = Object.keys(languagePrefixes);
  const langMap = { en: "English", es: "Español", de: "Deutsch", fr: "Français", uk: "Українська" };
  const currentLangName = langMap[currentLanguage] || "English";

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger
        className={cn(
          triggerClassName,
          "cursor-pointer bg-transparent w-full justify-start appearance-none"
        )}
      >
        <img src={languageIcon} alt="" className="h-5 w-5" />
        <span className="whitespace-nowrap">{currentLangName}</span>
        {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className={cn(
            "z-50 mt-1 min-w-[180px] rounded-lg border border-stone-200",
            "bg-white p-1.5 shadow-lg",
            "data-[state=open]:animate-in data-[state=closed]:animate-out",
            "data-[state=open]:fade-in data-[state=closed]:fade-out",
            "data-[side=bottom]:slide-in-from-top-1"
          )}
          side="bottom"
          sideOffset={6}
          align="start"
          avoidCollisions
          collisionPadding={10}
        >
          {languages
            .filter((code) => code !== currentLanguage)
            .map((code) => (
              <DropdownMenu.Item
                key={code}
                className={cn(
                  "my-0.5 flex w-full items-center justify-between rounded-md px-2 py-1.5",
                  "text-sm text-stone-950 outline-none cursor-pointer",
                  "hover:bg-stone-100"
                )}
                onSelect={() => {
                  changeLanguage(code);
                  onClick?.();
                  close();
                }}
              >
                {langMap[code] || code}
              </DropdownMenu.Item>
            ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default LanguageSwitcher;
